import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { QueryClientProvider } from "@tanstack/react-query"
import Theme from "@amzn/meridian/theme"
import { ThemeContextProvider } from "@amzn/lcars-core-ui-components"
import "@amzn/meridian-tokens/base/font/amazon-ember.css"
import App from "./App"
import { createQueryClient } from "./services/queryClient"
import wfmTheme from "./theme/wfm-theme.json"
import "./index.css"

const rootElement = document.getElementById("root")
if (!rootElement) throw new Error("Root element not found")

const queryClient = createQueryClient()

// Wrap the whole app in Meridian's Theme so Meridian components that resolve
// icon/colour tokens (e.g. Alert) work everywhere — including inside the
// ErrorBoundary. Uses the WFM green palette to match the Portal brand.
// QueryClientProvider backs the src/queries hooks (e.g. cross-screen location
// caching) without changing the useAsyncData/LoadState UX contract.
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Theme palette={wfmTheme}>
          <ThemeContextProvider>
            <App />
          </ThemeContextProvider>
        </Theme>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
